import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Language } from "../../assets/languages/langs";

import { CONNECTION_TEXT_KEY } from "./constants";
import { CONNECTION_TEXTS } from "./texts";

type Values = Record<string, string | number>;

/**
 * Text of the indicator by its short key (`level.good`, `hint.offline`...).
 * With `lang` it comes from the built-in dictionary: the login screen has no
 * server translations yet. Without it, from the loaded translations.
 */
const useConnectionText = (lang?: Language) => {
	const { t } = useTranslation();

	return useCallback(
		(key: string, values?: Values): string => {
			if (!lang) {
				return String(
					t(`${CONNECTION_TEXT_KEY}.${key}`, { ...values }),
				);
			}
			const text =
				CONNECTION_TEXTS[lang]?.[key] ?? CONNECTION_TEXTS.en[key];
			return (text ?? key).replace(/{{(\w+)}}/g, (_, name) =>
				String(values?.[name] ?? ""),
			);
		},
		[lang, t],
	);
};

export default useConnectionText;
